import { render, staticRenderFns } from "./PropertyMaintenanceSystemBreadcrumb.vue?vue&type=template&id=4971bc34"
import script from "./PropertyMaintenanceSystemBreadcrumb.vue?vue&type=script&lang=ts"
export * from "./PropertyMaintenanceSystemBreadcrumb.vue?vue&type=script&lang=ts"
import style0 from "./PropertyMaintenanceSystemBreadcrumb.vue?vue&type=style&index=0&id=4971bc34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports